/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Box, Grid, Icon } from '@material-ui/core';
import useStyles from './useStyles';
import { getTools } from '../../../constants';

const Tools = ({ onClickTool, toolType }) => {
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const classes = useStyles();
  const ToolArray = getTools(
    labels.DESIGNER_SEAT,
    labels.DESIGNER_SEATS,
    labels.DESIGNER_DOOR,
    labels.DESIGNER_WINDOW,
    labels.DESIGNER_AQUARIUM,
    labels.DESIGNER_PAINTING,
    labels.DESIGNER_RESTROOM,
    labels.DESIGNER_KITCHEN,
  );

  return (
    <Grid container className={cn(classes.gridContainer)}>
      {ToolArray.map(tool =>
        <Grid item key={tool.type} xs={6} sm={4} md={3} lg={2}>
          <Box
            m={0.5}
            p={1}
            onClick={() => onClickTool(tool)}
            className={cn(
              classes.gridBox,
              classes.toolBox,
              { [classes.selectedTool]: toolType === tool.type }
            )}>
            <Icon
              fontSize='large'
              className={cn(
                'material-icons-outlined',
                classes.toolIcon,
                { [classes.selectedToolIcon]: toolType === tool.type }
              )}
            >
              {tool.icon}
            </Icon>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default Tools;
